import ServiceCategoryPage from "../components/ServiceCategoryPage";
import steelRodWireWorkService from "../data/services/steelRodWireWorkService";

function SteelRodWireWork() {
  return <ServiceCategoryPage service={steelRodWireWorkService} />;
}

export default SteelRodWireWork;
